module.exports = __webpack_public_path__ + "img/OfferPage.10a66060.svg";